var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panel shadow-none pt-15 pl-15",
      attrs: { id: "homeReasonsDetalizationAllTimeCountsPanel" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.stats, function (stat, type) {
          return _c("div", { staticClass: "col-12 mb-20" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-2" }, [
                _c("div", { staticClass: "pearl red active" }, [
                  _c(
                    "span",
                    {
                      staticClass: "pearl-icon cursor-pointer",
                      class: stat.color,
                      style: stat.line_height_style,
                    },
                    [
                      stat.error
                        ? _c("span", { staticClass: "error" }, [
                            _c("i", {
                              staticClass: "fa fa-exclamation-triangle",
                              class: stat.color,
                              attrs: { "aria-hidden": "true" },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !stat.error && stat.loading
                        ? _c("span", { staticClass: "loading" }, [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-pulse",
                              class: stat.color,
                              attrs: { "aria-hidden": "true" },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !stat.error && !stat.loading
                        ? _c("span", { style: stat.font_style }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(stat.count) +
                                "\n              "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("span", { staticClass: "description-reason-detail" }, [
                  _vm._v(_vm._s(stat.title)),
                ]),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "panel-title text-center pr-0 pb-20" }, [
      _vm._v("Детализация причин (за всё время)\n    "),
      _c("i", {
        staticClass: "icon md-help-outline cursor-pointer",
        attrs: {
          "aria-hidden": "true",
          "data-toggle": "popover",
          "data-html": "true",
          "data-trigger": "click | hover",
          "data-content": "Рассчитывается на основании человек-группа",
          "data-original-title": "",
          title: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }